module.exports = __webpack_public_path__ + "img/framework.90e19163.png";